import PropTypes from "prop-types";
import { ReduceStore } from "flux/utils";
import Dispatcher from "Dispatcher";
import DevelopmentActions from "data/dev/DevelopmentActions";
import typeCheckingStore from "data/util/typeCheckingStore";
import ITTestStore from "data/dev/ITTestStore";

const LS_KEY = "IT_TEST_HISTORY";

const cleanPath = path => {
    if (path == null) return path;
    // everything is within this directory. we'll just blindly assume there
    // isn't an earlier duplicate instance in the url. :)
    const idx = path.indexOf("test/it/");
    return idx === 0
        ? path
        : path.substr(idx);
};

const recordResult = (state, success, message) => {
    const path = cleanPath(ITTestStore.getState().path);
    if (path == null) return state;
    state = {...state};
    state[path] = {
        success,
        message,
    };
    window.localStorage.setItem(LS_KEY, JSON.stringify(state));
    return state;
};

class ITTestHistoryStore extends ReduceStore {

    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        let state = null;
        try {
            state = JSON.parse(window.localStorage.getItem(LS_KEY));
        } catch (e) {
            state = null;
        }
        if (state == null) {
            state = {};
        }
        return state;
    }

    reduce(state, action) {
        switch (action.type) {
            case DevelopmentActions.IT_TEST_ERROR: {
                return recordResult(state, false, action.message);
            }

            case DevelopmentActions.IT_TEST_SUCCESS: {
                return recordResult(state, true);
            }

            case DevelopmentActions.RESET_IT_TEST_STATUS: {
                window.localStorage.removeItem(LS_KEY);
                return this.getInitialState();
            }

            default:
                return state;
        }
    }

}

ITTestHistoryStore.stateTypes = PropTypes.objectOf(
    PropTypes.exact({
        success: PropTypes.bool.isRequired,
        message: PropTypes.string,
    }));

export const isSuccess = (history, path) => {
    path = cleanPath(path);
    return history.hasOwnProperty(path) && history[path].success;
};

export const isError = (history, path) => {
    path = cleanPath(path);
    return history.hasOwnProperty(path) && !history[path].success;
};

export const getMessage = (history, path) => {
    path = cleanPath(path);
    return history.hasOwnProperty(path)
        ? history[path].message
        : null;
};

export default typeCheckingStore(new ITTestHistoryStore());



// WEBPACK FOOTER //
// ./app/data/dev/ITTestHistoryStore.js